import React, { useEffect } from 'react';
import { Routes as RouterRoutes, Route, useLocation, Navigate } from 'react-router-dom';
import Home from '../components/Home';
import TermsView from '../components/TermsView';
import PrivacyView from '../components/PrivacyView';
import CookieView from '../components/CookieView';
import AccessibilityView from '../components/AccessibilityView';
import MenuView from '../components/MenuView';
import AboutView from '../components/AboutView';
import CateringView from '../components/CateringView';
import CateringFormView from '../components/CateringFromView';
import LocationsView from '../components/LocationsView';
import LocationsBrentwoodView from '../components/LocationsBrentwoodView';
import LocationsConcordView from '../components/LocationsConcordView';
import LocationsHerculesView from '../components/LocationsHerculesView';
import LocationsMartinezView from '../components/LocationsMartinezView';
import LocationsPleasantHillView from '../components/LocationsPleasantHillView';
import LocationsWalnutCreekYgnacioView from '../components/LocationsWalnutCreekYgnacioView';
import ContactView from '../components/ContactView';
import CareersView from '../components/CareersView';
import RewardsView from '../components/RewardsView';
import BalanceView from '../components/BalanceView';
import Specials from '../components/Specials';

const Routes = () => {
    const location = useLocation();
    
    useEffect(() => {
        
        
        // AGGRESSIVE body class cleanup - remove ALL classes first
        document.body.className = '';
        
        // Remove html element classes
        const classesToRemove = ['backgroundColorWarmWhite', 'backgroundColorBlack'];
        document.documentElement.classList.remove(...classesToRemove);

        // Add the appropriate class based on the current path
        switch(location.pathname) {
            case '/':
            case '/our-story':
                document.documentElement.classList.add('backgroundColorBlack');
                break;
            case '/balance':
                document.documentElement.classList.add('backgroundColorWarmWhite');
                document.body.className = 'balance-page-body'; 
                break;
            default:
                document.documentElement.classList.add('backgroundColorWarmWhite');
                break;
        }
        
        
    }, [location]);

    return (
        <RouterRoutes>
            {/* Home routes */}
            <Route path="/" element={<Home />} />

            {/* Menu routes */}
            <Route path="/menu" element={<MenuView />} />
            <Route path="/menu/:categorySlug" element={<MenuView />} />

            {/* Location routes */}
            <Route path="/locations" element={<LocationsView />} />
            <Route path="/locations/brentwood" element={<LocationsBrentwoodView />} />
            <Route path="/locations/concord" element={<LocationsConcordView />} />
            <Route path="/locations/hercules" element={<LocationsHerculesView />} />
            <Route path="/locations/martinez" element={<LocationsMartinezView />} />
            <Route path="/locations/pleasant-hill" element={<LocationsPleasantHillView />} />
            <Route path="/locations/walnut-creek-parkside" element={<Navigate to="/locations/walnut-creek-ygnacio" replace />} />
            <Route path="/locations/walnut-creek-ygnacio" element={<LocationsWalnutCreekYgnacioView />} />

            {/* Catering routes */}
            <Route path="/catering" element={<CateringView />} />
            <Route path="/catering/request-quote" element={<CateringFormView />} />

            {/* Daily Specials routes */}
            <Route path='/daily-specials' element={<Specials />} />
            <Route path='/daily-specials/:day' element={<Specials />} />

            {/* Other routes */}
            <Route path="/contact" element={<ContactView />} />
            <Route path="/careers" element={<CareersView />} />
            <Route path="/rewards" element={<RewardsView />} />
            <Route path="/balance" element={<BalanceView />} />
            <Route path="/our-story" element={<AboutView />} />
            <Route path="/privacy-policy" element={<PrivacyView />} />
            <Route path="/terms-of-use" element={<TermsView />} />
            <Route path="/cookie-policy" element={<CookieView />} />
            <Route path="/web-accessibility" element={<AccessibilityView />} />
        </RouterRoutes>
    );
};

export default Routes;